<section class="row makePaymentView sanofi-statementsPage" id="productList-area">
  <aside class="col-md-2 col-sm-3 float-left" *ngIf="!showSection">
    <section class="vertical-banner"></section>
  </aside>
  <section class="{{ statementWidth }} col-xs-12 table-s-section float-right" [ngClass]="{ 'acc-overview-sp': showSection === true }">
    <section class="credits-section" [ngClass]="{ 'acc-overview-sp': showSection === true }">
      <section class="row my-4 my-lg-0">
        @if (statementsData?.dateMap?.length) {
          <section class="col-sm-6 col-md-6 col-xs-12 op_ovice pr-0" [ngClass]="{ 'acc-overview-sp': showSection === true }">
            <h5 class="font-bold mt-2 c-heading-h4" [ngClass]="{ 'acc-overview-sp': showSection === true }">
              {{ 'statements.statementList.title' | cxTranslate }}
            </h5>
          </section>
          <section class="my-4 my-md-0 d-flex justify-content-md-end col-6 col-md-6 col-sm-6 col-xs-12 text-right openstatement-btn align-items-center">
            <button type="button" (click)="viewCurrent()" class="c-button c-button--secondary mr-2"
                    [ngClass]="{ 'acc-overview-sp': showSection === true }">
              <img src="icons/document_icon.svg" alt="View statement detail" class="sanofi-statementsPage__viewDetailsIcon mr-1">
              {{ 'statements.mainViewBtn' | cxTranslate }}
            </button>
            <sanofi-statements-pdf-download
              [accountNumber]="accountId"
              [isCustomerEmulated]="isCustomerEmulated"
              [toDate]="getViewAllDate()"
              [generateAllBtn]="true"
              [showSection]="showSection"
              class="statementsFileDownload"
              [salesOrg]="salesOrg()"
            />
          </section>
        }
      </section>
    </section>

    <sanofi-statements-list
      [statementsList]="statementsData?.dateMap.slice(0, recordLength) || []"
      [accountId]="accountId"
      [isCustomerEmulated]="isCustomerEmulated"
      (onStatementView)="openNewModalPopup($event.value, $event.key)"
      [widgetView]="widgetView()"
      [salesOrg]="salesOrg()"
    />
  </section>
</section>
